export default class Claim {
    constructor() {
        this.id;
        this.providerId;
        this.incidentId;
        this.patientId;
        this.fundingType;
        this.createdByUserId;
        this.createdAt;
        this.isDeleted;
        this.claimBatches = [];
        this.dayBatchId;
        this.printedVerified;
        this.linkNumber;
        this.podFileId;
        this.patientId;
        this.objectionLetterFileId;
        this.rejectionLetterFileId;
        this.isObjectionResolved;
        this.isRejectionResolved;
        this.totalAmountClaimed;
        this.paymentReceived;

        this.isFinal;
        this.notes = [];
        this.status;
        this.queryLetterFileId;
        this.resubmissionPodFileId;
    }

    set(setEntity) {
        this.id = setEntity.id;
        this.providerId = setEntity.providerId;
        this.incidentId = setEntity.incidentId;
        this.patientId = setEntity.patientId;
        this.fundingType = setEntity.fundingType;
        this.createdByUserId = setEntity.createdByUserId;
        this.createdAt = setEntity.createdAt;
        this.isDeleted = setEntity.isDeleted;
        this.claimBatches = setEntity.claimBatches ? setEntity.claimBatches : [];
        this.dayBatchId = setEntity.dayBatchId;
        this.printedVerified = setEntity.printedVerified;
        this.linkNumber = setEntity.linkNumber;
        this.podFileId = setEntity.podFileId;
        this.patientId = setEntity.patientId;
        this.objectionLetterFileId = setEntity.objectionLetterFileId;
        this.rejectionLetterFileId = setEntity.rejectionLetterFileId;
        this.isObjectionResolved = setEntity.isObjectionResolved;
        this.isRejectionResolved = setEntity.isRejectionResolved;
        this.totalAmountClaimed = setEntity.totalAmountClaimed;
        this.paymentReceived = setEntity.paymentReceived;

        this.isFinal = setEntity.isFinal;
        this.notes = setEntity.notes ? setEntity.notes : [];
        this.status = setEntity.status;
        this.queryLetterFileId = setEntity.queryLetterFileId;
        this.resubmissionPodFileId = setEntity.resubmissionPodFileId;

        return this;
    }
}
